import PropTypes from "prop-types";

import BaseField from "../../ui/BaseField";
import ValueWithFallback from "../../ui/ValueWithFallback";

const PreApprovedMedicalAmount = ({ fieldName, value, flag, clock }) => {
  return (
    <BaseField
      id="SB-ProviderMax"
      testId="SB-ProviderMax"
      fieldName={fieldName}
      label={"Preapproved Medical Amount"}
      value={value}
      flag={flag}
      clock={clock}
    >
      <span>{ValueWithFallback(value)}</span>
    </BaseField>
  );
};

export default PreApprovedMedicalAmount;

PreApprovedMedicalAmount.propTypes = {
  fieldName: PropTypes.string,
  value: PropTypes.any,
  flag: PropTypes.any,
  clock: PropTypes.any,
};
